<template>
    <v-app>

        <div class="container">
            <v-row>
                <v-col cols="1" >
                    <div>
                        <v-img width="96" height="100" :lazy-src="img_arin" :src="img_arin"></v-img>
                    </div>
                </v-col>
                <v-col cols="10" >
                    <div class="font-14">บริษัท เอสธีท เมดิคอล จำกัด</div>
                    <div class="font-14">111/76 หมู่ที่ 2 ตำบลหนองหอย อำเภอเมืองเชียงใหม่ จ.เชียงใหม่ 50000</div>
                    <div class="font-14">Tel. 052-062-622   FAX.052-062-622   Email : arinclinic@hotmail.com</div>
                    <div class="font-14">เลขประจำตัวผู้เสียภาษีอากร 0505564000230</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12 bold font-16 pt-5 pb-8 ">
                    <div class="text-center">ใบแจ้งหนี้/ใบกำกับภาษี</div>
                    <div class="text-center">TAX INVOICE</div>
                </v-col>
            </v-row>
            <div class="title_page">
                <v-row class="border-tax py-3 mb-2 input-radius  mr-6" style="width: 60%;">
                    <v-col cols="12 pt-1 pb-1 font-14 text-grey">ชื่อผู้ซื้อ : บริษัท ก.ข.ค. จำกัด (สำนักงานใหญ่)</v-col>
                    <v-col cols="12 pt-1 pb-1 font-14 text-grey">ที่อยู่ : 222 ถ.พหลโยธิน แขวงสามเสนใน เขตพญาไท กรุงเทพฯ 10400</v-col>
                    <v-col cols="12 pt-1 pb-1 font-14 text-grey">เลขประจำตัวผู้เสียภาษี : 012345678912</v-col>
                </v-row>
                <v-row class="border-tax py-3 mb-7 input-radius " style="width: 40%;">
                    <v-col cols="12 pt-1 pb-1 font-14 text-grey">วันที่ : 9 ธันวาคม 2565</v-col>
                    <v-col cols="12 pt-1 pb-1 font-14 text-grey">เลขที่ใบกำกับภาษี/เล่มที่ : 001/002</v-col>
                    <v-col cols="12 pt-1 pb-1 font-14 text-grey">วันครบกำหนดชำระเงิน : 30 มกราคม 2566</v-col>
                </v-row>
            </div>
            <v-row class="border-tax input-radius">
                <v-col class="12 pb-0">
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center" width="80">
                                        <div class="font-12 text-grey"> ลำดับ </div>
                                        <div class="font-12 text-grey"> No. </div>
                                    </th>
                                    <th class="text-left">
                                        <div class="font-12 text-grey"> รายการสินค้า </div>
                                        <div class="font-12 text-grey"> Description </div>
                                    </th>
                                    <th class="text-center">
                                        <div class="font-12 text-grey"> จำนวน </div>
                                        <div class="font-12 text-grey"> Quantity </div>
                                    </th>
                                    <th class="text-right">
                                        <div class="font-12 text-grey mr-5"> ราคาต่อหน่วย </div>
                                        <div class="font-12 text-grey mr-7"> Unit Price </div>
                                    </th>
                                    <th class="text-right" width="150">
                                        <div class="font-12 text-grey mr-3"> จำนวนเงิน (บาท) </div>
                                        <div class="font-12 text-grey mr-3"> Amount (Baht) </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in data_list" :key="item.name">
                                    <td class="text-center font-14 h-40">
                                        <div class="font-14">{{ item.product_no }}</div>
                                    </td>
                                    <td class="h-40">
                                        <div class="font-14">{{ item.product_name }}</div>
                                    </td>
                                    <td class="text-center font-14 h-40">
                                        <div class="font-14">{{ item.product_unit }}</div>
                                    </td>
                                    <td class="text-right font-14 h-40">
                                        <div class="mr-3 font-14">
                                            {{ item.product_price }}
                                        </div>
                                    </td>
                                    <td class="text-right h-40">
                                        <div class="mr-3 font-14">{{ item.product_sum }}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="bb-0 h-40"></td>
                                    <td class="bb-0 h-40"></td>
                                    <td colspan="2" class="text-right font-12 h-40">
                                        <div class="font-12">รวมเงิน (Sub Total)</div> 
                                    </td>
                                    <td class="text-right h-40" style="height: 40px;">
                                        <div class="mr-3 font-12">171.00</div> 
                                    </td>
                                </tr>
                                <tr>
                                    <td class="bb-0 h-40"></td>
                                    <td class="bb-0 h-40"></td>
                                    
                                    <td colspan="2" class="text-right font-12 h-40">
                                        <div class="font-12">ส่วนลด (Discount)</div>
                                    </td>
                                    <td class="text-right h-40">
                                        <div class="mr-3 font-12">81.00</div> 
                                    </td>
                                </tr>
                                <tr>
                                    <td class="bb-0 h-40"></td>
                                    <td class="bb-0 h-40"></td>
                                   
                                    <td colspan="2" class="text-right font-12 h-40">
                                        <div class="font-12">ยอดเงินคงเหลือ (Total)</div>
                                    </td>
                                    <td class="text-right h-40">
                                        <div class="mr-3 font-12">100.00</div> 
                                    </td>
                                </tr>
                                <tr>
                                    
                                    <td colspan="4" class="text-right font-12 h-40">
                                        <div class="font-12">ภาษีมูลค่าเพิ่ม (VAT) 7%</div>
                                    </td>
                                    <td class="text-right h-40">
                                        <div class="mr-3 font-12">7.00</div> 
                                    </td>
                                </tr>
                                <tr>
                                    <td class="h-40"></td>
                                    <td class="font-12 h-40">
                                        <div class="font-12">หนึ่งร้อยเจ็ดบาทถ้วน</div>
                                    </td>
                                  
                                    <td colspan="2" class="text-right font-12 h-40">
                                        <div class="font-12">ยอดเงินสุทธิ (NET Total)</div>
                                    </td>
                                    <td class="text-right h-40">
                                        <div class="mr-3 font-12">107.00</div> 
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row class="mb-5">
                <v-col cols="12 pb-0 pt-5">
                    <div class="font-12 text-grey">ชำระสินค้า โดย :</div>
                </v-col>
                <v-col cols="2 font-12 text-grey">(    )   เงินสด</v-col>
                <v-col cols="2 font-12 text-grey">(    )   เงินโอน</v-col>
                <v-col cols="2 font-12 text-grey">(    )   บัตรเคดิต</v-col>
                <v-col cols="6 font-12 text-grey">(    )   อื่นๆ  ระบุ ...........................................................................</v-col>
            </v-row>
            <v-row class="mt-5">
                <v-col cols="6 text-center font-12 text-grey">
                    ลงชื่อ ...................................................................... ผู้รับสินค้า
                </v-col>
                <v-col cols="6 text-center font-12 text-grey">
                    ลงชื่อ ...................................................................... ผู้รับเงิน
                </v-col>
                <v-col cols="6 text-center font-12 text-grey">
                    วันที่ ......................................................................
                </v-col>
                <v-col cols="6 text-center font-12 text-grey">
                    วันที่ ......................................................................
                </v-col>
            </v-row>
        </div>

    </v-app>
</template>
  
<script>

import img_arin from "@/assets/arin_assets/arin.png";

export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_bill_after",
    data() {
        return {
            loading_page: false,
            dialog_cancel_order: false,
            search: '',
            img_arin :img_arin,

            footer_Props:{
                'items-per-page-text':'รายการต่อหน้า'
            },
            data_list: [
                {
                    product_no: '1',
                    product_name: 'tab.CARATEN 12.5 MG.BX 100 s 1300.-',
                    product_unit: '1 แผง',
                    product_price: '9.00',
                    product_sum: '9.00',
                },
                {
                    product_no: '2',
                    product_name: 'eent.NODOGLE SPRAY 15 ML. 150.-',
                    product_unit: '1 กล่อง',
                    product_price: '102.00',
                    product_sum: '102.00',
                },
            ],
            
        }
    }, 
    methods: {
        link(link){
            window.location.href = link;
        },
    },
}
</script>
  
<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  /* width: 100%; */
}
.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 45px;
    padding: 0 10px;
}
.border-tax{
    border: 1px solid #B7B7B7;
}

.border-style-b {
    /* border-style: dotted;
    border-color: #ADADAD; */
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 1px dotted #ADADAD;
}
.title_page_right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.title_page_center {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.font-14{
    font-size: 14px !important;
}

.font-12{
    font-size: 12px !important;
}

.h-40
{
    height: 35px !important;
}

.bb-0{
    border-bottom:0px !important;
}

</style>
  